"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var queryString = require("query-string");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var search_1 = require("utils/search");
var SearchBar_1 = require("./SearchBar");
var Tools_1 = require("./Tools");
var ListContainer_1 = require("./ListContainer");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('queryParams', 'setQueryParams', null), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var params = parseSearchString(this.props.location);
        var updatedParams = __assign(__assign({}, ListContainer_1.defaultParams), params);
        var url = this.props.location.pathname + (0, search_1.getQueryParams)(updatedParams);
        this.props.history.replace(url);
        this.props.setQueryParams(updatedParams);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            var params = parseSearchString(this.props.location);
            var updatedParams = __assign(__assign({}, ListContainer_1.defaultParams), params);
            this.props.setQueryParams(updatedParams);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.location.search !== nextProps.location.search ||
            this.props.queryParams !== nextProps.queryParams) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
function parseSearchString(location) {
    var params = queryString.parse(location.search);
    var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
    // Decode params
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        params[key] = decodeURIComponent(params[key]);
    }
    return params;
}
exports.default = enhance(function (props) {
    if (props.queryParams === null) {
        return React.createElement("div", null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'customer-management-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/" }, "SokoPro"),
                        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/system/customerManagement'))),
                    React.createElement(SearchBar_1.default, __assign({}, props, { updateUrl: props.history.push, queryParams: props.queryParams, pathname: props.location.pathname })),
                    React.createElement(ListContainer_1.ListContainer, { updateUrl: props.history.push, queryParams: props.queryParams, pathname: props.location.pathname })))),
        React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'customer-management-view-tools-container' },
            React.createElement(Tools_1.default, null))));
});
